/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useCallback, useEffect, useRef } from "react";
import styles from "./dailyPhasing.module.css";
import { CircularProgress } from "@mui/material";
import {
    getMMInputDetails, submitMMInputData, saveDraftMMInputData,
    get_cascade_line_list, get_cbu_line_level_data, get_cbu_level_data,
    getAeraPlanThursdayPlan, getOverloadedData, handleTrackingUpdate
} from "Samarth Module/api/DailyphaingAPIs.js";
import { exportToExcelFile } from "Samarth Module/api/api";
import { smartProdSchedularInputFields, smartProdSchedularChipsCols, smartProdSchedularDropdownCols }
    from "Samarth Module/constants/dailyPhasing";
import SnackBarMessage from "Samarth Module/components/snackbar/snackbar";
import { useDailyPhasingContext } from "../../../utils/dailyphaisngContext/DailyphasingContext";
import CustomButton from "../../components/buttons/CustomButton";
import MMScreenInputLanding from "./Component/MMScreenInputLanding";
import { useMsal } from "@azure/msal-react";
import { isButtonEnabled, differentiateRowsByDate, cascadeLineOptions, timeBasedFlag, getWeekFilterOptions, getWeekBasedFlag, hasS1Flag } from "../../../utils/mmScreenInput";
import usePreventUnload from "./hooks/usePreventUnload";
import AeranSubmitAlertPopup from "Samarth Module/components/popup/aeranSubmitAlertPopup";

const CustomTabPanel = ({ children, value, index }) =>
    value === index && <div>{children}</div>;

/* createColumns */
const createColumns = (base, config = {}) => {
    return [...base].map((item) => ({
        ...item,
        "label": item["label"].endsWith('_1') ? item["label"].replace('_1', '') : item["label"],
        "sortable": config.noSortKeys ? !config.noSortKeys.includes(item["label"]) : true,
        "input": config.inputKeys?.includes(item["label"].endsWith('_1') ? item["label"].replace('_1', '') : item["label"]) ?? false,
        "chip": config.chipKeys?.includes(item["label"].endsWith('_1') ? item["label"].replace('_1', '') : item["label"]) ?? false,
        "dropdown": config.dropdownKeys?.includes(item["label"].endsWith('_1') ? item["label"].replace('_1', '') : item["label"]) ?? false,
    }))
};

const DailyPhasingContainer = ({ type }) => {
    const { addedRows, btnDisable, setAddedRows, editableTableData, setTableData, setFilteredTableData,
        setEditableTableData, setFilteredEditableTableData,
        setTableDataColumns,
        setEditableTableDataColumns,
        setGlobalFilters,
        setEditableTableFilters, setThresoldValue, setSaveComments, setCascadeLineList, duplicateRows, handleIdToken, selectedWeek } = useDailyPhasingContext();

    const { accounts } = useMsal();
    const activeAccount = accounts[0];
    const [loader, setLoader] = useState(false);
    const [screenView, setScreenView] = useState(type === 'MM Screen Input' ? 0 : 1);
    const [excelLoading, setExcelLoading] = useState(false);
    const [snackBarObject, setSnackBarObject] = useState({
        snackbarOpen: false,
        message: "",
        type: "error",
    });
    const [alertType, setAlertType] = useState({ type: '', data: [] });

    const effectRan = useRef(false);

    usePreventUnload(loader);

    const handleError = useCallback((message) => {
        setSnackBarObject({ snackbarOpen: true, message, type: "error" });
    }, []);

    const successHandler = useCallback((message) => {
        setSnackBarObject({ snackbarOpen: true, message, type: "success" });
    }, []);

    const closeSnackbar = useCallback(() => {
        setSnackBarObject((prev) => ({ ...prev, snackbarOpen: false }));
    }, []);

    const reloadTblData = useCallback(async (btnType) => {
        try {
            let editableData = [], thresold = [], comments = [];
            const username = activeAccount.username;
            let promise1;
            if (btnType === 'submit') {
                promise1 = await cbu_level_derived_data(username); // data for the both the table
            }
            const promise2 = await cbu_line_level_derived_data(username); // data for the both the table
            const promise3 = await get_cascade_line_list(accounts[0].idToken); // add new cbu and cascade & line dropdown values
            const promises = btnType === 'submit' ? [promise2, promise1, promise3] : [promise2, promise3];
            const results = await Promise.all(promises);

            if (results && results.length) {
                const getData = results[0];
                const list = btnType === 'submit' ? results[2] : results[1];
                if (getData && list && Object.keys(list).length) {
                    const cascadeLineList = cascadeLineOptions(list.cascade_line, ["Site code"]);
                    editableData = [...getData].map((item, i) => {
                        const key = ["Site code"].map(key => item[key] || "").join(":");
                        const match = cascadeLineList.get(key);
                        return {
                            ...item,
                            id: i,
                            isUpdated: false,
                            isAdded: false,
                            cascadeOptions: match?.cascades || [],
                            lineOptions: match?.lines || [],
                            constValues: {
                                Cascade: item["Cascade"],
                                Line: item["Line"],
                                Mon: item["Mon"],
                                Tue: item["Tue"],
                                Wed: item["Wed"],
                                Thu: item["Thu"],
                                Fri: item["Fri"],
                                Sat: item["Sat"],
                                Sun: item["Sun"],
                                preCascade: item["PreCascade"],
                                preLine: item["PreLine"],
                                "Reason for change": item["Reason for change"]
                            }
                        };
                    });
                    // thresold = [...getData["thresold_value"]];
                }
            }
            if (btnType === 'submit') {
                const cbuLevelData = [...results[1]].map((item, i) => {
                    return { ...item, id: i }
                });
                setTableData(cbuLevelData);
                setFilteredTableData(cbuLevelData);
            }
            setEditableTableData(editableData);
            setFilteredEditableTableData(editableData);
            setThresoldValue(thresold);
            setSaveComments(comments);
        } catch (err) {
            handleError(err?.message || 'An unexpected error occurred');
        }
    }, [activeAccount.username])

    // fetch initial data
    const fetchData = useCallback(async (weekValue = null) => {
        setLoader(true);
        try {
            let data = [], editableData = [], dtColumns = [], etColumns = [], globalFilters = [], editableTableFilters = [], thresold = [], comments = [];
            handleIdToken(accounts[0].idToken);
            // Use provided weekValue, or selectedWeek, or get default from getWeekFilterOptions
            const weekToUse = weekValue || selectedWeek || getWeekFilterOptions()[0] || "";
            // Get the flag based on selected week and current day
            const flagToUse = getWeekBasedFlag(weekToUse);
            const promise1 = await getMMInputDetails(activeAccount.username, type, activeAccount?.idTokenClaims?.roles, flagToUse, +weekToUse.replace('Week ', ''));
            const promise2 = await get_cascade_line_list(accounts[0].idToken);
            const promises = [promise1, promise2];
            const results = await Promise.all(promises);


            if (results && results.length) {
                const getData = results[0];
                const list = results[1];
                setCascadeLineList(list.cascade_line);
                if (getData && Object.keys(getData).length && list && Object.keys(list).length) {
                    const cascadeLineList = cascadeLineOptions(list.cascade_line, ["Site code"]);
                    data = [...getData["cbu_level_plan"].map((item, i) => {
                        return { ...item, id: i }
                    })];
                    editableData = [...getData["line_cbu_level_plan"]].map((item, i) => {
                        const key = ["Site code"].map(key => item[key] || "").join(":");
                        const match = cascadeLineList.get(key);
                        return {
                            ...item,
                            id: i,
                            isUpdated: false,
                            isAdded: false,
                            cascadeOptions: match?.cascades || [],
                            lineOptions: match?.lines || [],
                            constValues: {
                                Cascade: item["Cascade"],
                                Line: item["Line"],
                                Mon: item["Mon"],
                                Tue: item["Tue"],
                                Wed: item["Wed"],
                                Thu: item["Thu"],
                                Fri: item["Fri"],
                                Sat: item["Sat"],
                                Sun: item["Sun"],
                                "Reason for change": item["Reason for change"]
                            }
                        }
                    });

                    dtColumns = [...createColumns([...getData['defaultTableColumns1']], { chipKeys: [...smartProdSchedularChipsCols] })]
                    etColumns = [...createColumns([...getData['defaultTableColumns2']], {
                        noSortKeys: [...smartProdSchedularInputFields, ...smartProdSchedularDropdownCols],
                        inputKeys: smartProdSchedularInputFields,
                        chipKeys: [...smartProdSchedularChipsCols],
                        dropdownKeys: smartProdSchedularDropdownCols,
                    })]

                    editableTableFilters = [...getData['defaultFilterColumns2']];
                    globalFilters = [...getData["defaultFilterColumns1"]];
                    // thresold = [...getData["thresold_value"]];
                }
            }
            setTableData(data);
            setFilteredTableData(data);
            setEditableTableData(editableData);
            setFilteredEditableTableData(editableData);
            setTableDataColumns(dtColumns);
            setEditableTableDataColumns(etColumns);
            setThresoldValue(thresold);
            setGlobalFilters(!localStorage.getItem("cbuLevelPlanFilters") || !JSON.parse(localStorage.getItem("cbuLevelPlanFilters")).length ? globalFilters : JSON.parse(localStorage.getItem("cbuLevelPlanFilters")));
            setEditableTableFilters(!localStorage.getItem("lineCbuLevelPlanFilters") || !JSON.parse(localStorage.getItem("lineCbuLevelPlanFilters")).length ? editableTableFilters : JSON.parse(localStorage.getItem("lineCbuLevelPlanFilters")));
            setSaveComments(comments);
        } catch (err) {
            handleError(err?.message || 'An unexpected error occurred');
        } finally {
            setLoader(false);
            isAeraSubmitAlertEnabled(); // once aera plan changes done
        }
    }, [handleError, setTableData, setEditableTableData, setTableDataColumns, setEditableTableDataColumns, setGlobalFilters, setEditableTableFilters, setFilteredTableData, setFilteredEditableTableData, setThresoldValue, setSaveComments, activeAccount?.idTokenClaims?.roles, activeAccount.username, type])

    // function to handle tracking update - sends 1 row per entry (before differentiateRowsByDate splits it into 7)
    const handleTracking = useCallback(async (payload, username) => {
        try {
            const trackingPayload = payload.map(item => ({
                ...item, 
                'User Id': username
            }));
            console.log("Tracking payload", trackingPayload);
            await handleTrackingUpdate(trackingPayload);
        } catch (err) {
            console.error("Tracking update error:", err?.message || 'An unexpected error occurred');
        }
    }, []);

    // function for submitting the dps data
    const submitHandler = useCallback(async () => {

        setExcelLoading(true);
        try {
            const data = [...addedRows.concat([...editableTableData])];
            if (!Array.isArray(data) || data.length === 0) throw new Error("something went wrong");
            const filterData = data.filter(item => item.isUpdated || item.isAdded || item.IsDraft || item.IsAddNewCBU || item.IsDuplicateRow);

            if (!filterData.length) {
                throw new Error("No data was changed");
            }
            
            // Prepare payload for submit API (splits 1 row into 7 rows)
            const payload = filterData.map(obj => {
                const newObj = { ...obj };
                return differentiateRowsByDate(newObj, false);
            }).flat();
            let sortedPayload = payload.length ? payload.sort((a, b) => a.IsIgnore - b.IsIgnore) : [];
            // Call submit API
            handleAlertPopup();
            const response = await submitMMInputData(sortedPayload, activeAccount?.name || "");
            if (response?.status === "success") {
                // Call tracking API with original data (1 row per entry, before splitting)
                await handleTracking(filterData, activeAccount?.username || "");
                setAddedRows([])
                await reloadTblData('submit');
                successHandler(response?.message || "Data submitted successfully");
            }
        } catch (err) {
            handleError(err?.message || 'An unexpected error occurred');
        } finally {
            setExcelLoading(false);
        }
    }, [reloadTblData, handleError, successHandler, addedRows, activeAccount, editableTableData, setAddedRows])

    // function for drafting the data of dps
    const saveDraftHandler = useCallback(async () => {
        setExcelLoading(true);
        try {
            const data = [...addedRows.concat([...editableTableData])];
            if (!Array.isArray(data) || data.length === 0) throw new Error("something went wrong");
            const filterData = data.filter(item => item.isUpdated || item.isAdded || item.IsAddNewCBU || item.IsDuplicateRow);
            if (!filterData.length) {
                throw new Error("No data has been changed");
            }

            const payload = filterData.map(obj => {
                const newObj = { ...obj };
                return differentiateRowsByDate(newObj, true);
            }).flat();
            let sortedPayload = payload.length ? payload.sort((a, b) => a.IsIgnore - b.IsIgnore) : [];
            const response = await saveDraftMMInputData(sortedPayload, activeAccount?.name || "");
            if (response?.status === "success") {
                setAddedRows([]);
                await reloadTblData('draft');
                successHandler(response?.message || "Data saved as draft successfully");
            }
        } catch (err) {
            handleError(err?.message || 'An unexpected error occurred');
        } finally {
            setExcelLoading(false);
        }
    }, [reloadTblData, handleError, successHandler, addedRows, setAddedRows, activeAccount, editableTableData])

    // function for updated cbu line table entries after submit/save draft
    const cbu_line_level_derived_data = async () => {
        try {
            const username = activeAccount.username;
            const response = await get_cbu_line_level_data(username, timeBasedFlag());
            return response['line_cbu_level_plan'];
        } catch (err) {
            console.log(err);
        }
    }

    // function for updated cbu table entries after submit
    const cbu_level_derived_data = async () => {
        try {
            const username = activeAccount.username;
            const response = await get_cbu_level_data(username, timeBasedFlag());
            return response['cbu_level_plan'];
        } catch (err) {
            console.log(err);
        }
    }


    useEffect(() => {
        if (effectRan.current && window.location.pathname === '/samarth/smart_production_scheduler') {
            fetchData();
            if(!localStorage.getItem("isAeraPopupVisible") && new Date().getDay() === 4){ // Thursday
                localStorage.setItem("isAeraPopupVisible", true);
            }
        }
        return () => {
            effectRan.current = true;
        }
    }, []);

    // Refetch data when selectedWeek changes
    useEffect(() => {
        if (selectedWeek && window.location.pathname === '/samarth/smart_production_scheduler') {
            fetchData(selectedWeek);
        }
    }, [selectedWeek, fetchData]);



    const exportToExcel = useCallback(async (data, type) => {
        try {
            setExcelLoading(true);
            const filteredData = [...data].filter(item => !item.IsAddNewCBU && !item.IsDuplicateRow);
            await exportToExcelFile(filteredData, type);
        } catch (error) {
            setSnackBarObject({ snackbarOpen: true, message: error.message, type: 'error' })
        } finally {
            setExcelLoading(false);
        }
    }, [])

    const disabled = isButtonEnabled();

    // Check if today is Thursday to set the flag
    const isAeraSubmitAlertEnabled = async () => {    
        const currentDate = new Date();
        const currentDay = currentDate.getDay();
        if (currentDay === 4 && localStorage.getItem("isAeraPopupVisible") === 'true') { // 4 represents Thursday
            const tableData = await aeraPlanData();
            setAlertType({ type:'thursday', data: tableData });
        } else if (currentDay === 5 ) {
            localStorage.removeItem("isAeraPopupVisible");
        }
    };

    const handleAlertPopup = () => {
        setAlertType({ type: '', data: [] });
        localStorage.setItem("isAeraPopupVisible", false);
    }

    // Fetch or compute the AERA plan data here
    const aeraPlanData = async () =>{
        try{
            const aeraPlan = await getAeraPlanThursdayPlan();
            
            if(aeraPlan?.status === 'success'){
                return aeraPlan.aera_plan_details > 0 ? aeraPlan.aera_plan_details : "No AERA plan changes are observed in this week.";
            } else {
                return [];
            }
        } catch(error){
            console.log("Error fetching AERA plan data:", error);
            return [];
        }
    }

    const checkOverLoadingDataOnSubmit = async() => {
        // Logic to populate overrideData
        const data = [...addedRows.concat([...editableTableData])];
        if (!Array.isArray(data) || data.length === 0) throw new Error("something went wrong");
        const filterData = data.filter(item => item.isUpdated || item.isAdded || item.IsAddNewCBU || item.IsDuplicateRow);

        if (!filterData.length) {
            setSnackBarObject({ snackbarOpen: true, message: "No data changes happened for submit", type: "error" });
            return;
        }
        const uniqueLineSet = new Set(filterData.map(item => item["Line"]));

        const payload = data
            .filter(item => uniqueLineSet.has(item["Line"]))
            .sort((a, b) => {
                const lineA = a["Line"];
                const lineB = b["Line"];
                return String(lineA).localeCompare(String(lineB), undefined, { numeric: true });
            }).map(item => ({
                "Site code": item["Site code"] || "",
                "CBU code": item["CBU code"] || "",
                "Cascade": item["Cascade"] || "",
                "Line": item["Line"] || "",
                "Total":
                    (Number(item["Mon"]) +
                        Number(item["Tue"]) +
                        Number(item["Wed"]) +
                        Number(item["Thu"]) +
                        Number(item["Fri"]) +
                        Number(item["Sat"]) +
                        Number(item["Sun"])) || 0,
                "Tons per Shift": item["Tons per Shift"] || 0
            }));

            try{
                const overloadapiCall = await getOverloadedData(payload);
                if(overloadapiCall.data?.['summary'].overloaded){
                    const overloadedData = overloadapiCall.data?.details.filter(item => item['Status'].toLowerCase() === 'overloaded').map(item => ({
                        "Site code": item["Site code"] || "",
                        "Line": item["Line"] || "",
                    }));
                    setAlertType({ type: 'submit', data: overloadedData });
                } else{
                    // setAlertType({ type: 'submit', data: [] });
                    await submitHandler();
                }
            } catch (error) {
                setAlertType({ type: 'submit', data: [] });
            }
    }

    return (
        <Fragment>
            <div className={`${styles.container} ${excelLoading ? styles.blurBackground : ''}`}>
                <div className={styles.dataCard}>

                    {loader ? <div className={styles.loaderContainer}><CircularProgress /></div> : (
                        <>
                            <CustomTabPanel value={screenView} index={0} >
                                <MMScreenInputLanding
                                    activeAccount={activeAccount}
                                    exportToExcel={(tableData, type) => exportToExcel(tableData, type)}
                                />
                            </CustomTabPanel>
                            <CustomTabPanel value={screenView} index={2} ></CustomTabPanel>
                        </>
                    )}
                </div>
                <div className={styles.bottomPanel} style={{ position: excelLoading ? 'relative' : 'fixed' }}>
                    <CustomButton disabled={loader || !disabled || btnDisable || hasS1Flag([...addedRows, ...editableTableData])} label="Save draft" type="mm-save" onClick={saveDraftHandler} />
                    <CustomButton disabled={loader || !disabled || btnDisable || hasS1Flag([...addedRows, ...editableTableData])} label="Submit" type="mm-submit" onClick={() => checkOverLoadingDataOnSubmit()} />
                </div>
            </div>
            {excelLoading && <div className={styles.loaderExcelContainer}><CircularProgress /></div>}
            {snackBarObject.snackbarOpen && (
                <SnackBarMessage
                    type={snackBarObject.type}
                    snackbarMessage={snackBarObject.message}
                    snackbarOpen={snackBarObject.snackbarOpen}
                    setSnackbarOpen={closeSnackbar}
                />
            )}
            {alertType.type !== '' &&
                <div>
                    <AeranSubmitAlertPopup
                        type={alertType.type}
                        tableData={alertType.data}
                        submitHandler={submitHandler}
                        handleAlertPopup={handleAlertPopup}
                        label={excelLoading ? "Submitting..." : "Proceed to Submit"}
                    />
                </div>
            }
        </Fragment>
    )
}

export default React.memo(DailyPhasingContainer);
